import { PageTypeSuffix } from '@/constants'
import { type Post } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
interface PostListType {
  post: Post[]
}

export const PostList = ({ post }: PostListType) => {
  return (
    <div className={`container mt-4`}>
      <div className='flex items-center relative mb-2'>
        <h6 className='font-semibold text-base text-dark-900'>
          Tin tức & khuyến mãi
        </h6>
        <Link
          href='/post'
          className='absolute right-0 top-1/2 -translate-y-1/2 block text-sm font-medium text-primary-base'
        >
          Xem thêm
        </Link>
      </div>
      <div className='flex w-full overflow-x-auto gap-2'>
        {post &&
          post?.map((e, i) => {
            return (
              <div className='w-max min-w-[70%] flex-[0_0_70%]' key={i}>
                <div
                  className={`overflow-hidden rounded-lg h-full ${
                    i % 2 == 0 ? 'bg-white' : 'bg-primary-base'
                  }`}
                >
                  <div className='grid grid-cols-5 gap-2 items-stretch h-full'>
                    <div className='description p-5 pr-2 col-span-3 flex flex-col gap-1 h-full'>
                      <h3
                        className={`text-sm font-semibold text-left mb-2 leading-tight ${
                          i % 2 == 0 ? 'text-dark-800' : 'text-white'
                        }`}
                      >
                        {getTranslate(e?.title)}
                      </h3>
                      <Link
                        href={`/${getTranslate(e?.slugs.value)}${
                          e?.slugs.postfix
                        }${PageTypeSuffix.POST}`}
                        className={`h-7 px-3 font-semibold rounded text-xs flex justify-center items-center w-max ${
                          i % 2 == 0
                            ? 'text-white bg-primary-base'
                            : 'bg-white text-dark-900'
                        }`}
                      >
                        Xem thêm
                      </Link>
                    </div>
                    <ImageOptimize
                      src={e?.images[0]}
                      className='object-cover w-full h-full col-span-2'
                      width={404}
                      height={227}
                      loading='lazy'
                      alt={getTranslate(e?.title)}
                    />
                  </div>
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default PostList
